import React from "react";
import PluginPlaceholder from "../../_editor/components/canvas/plugin_placeholder/PluginPlaceholder";
import "./_ordering.scss";
import i18n from "i18next";
import { contentT } from "../../common/content_language";
import {
  letterFromNumber,
  getRandomColor,
  setRgbaAlpha,
  getButtonText,
} from "../../common/common_tools";
import colorManager from "../../_editor/components/common/color-picker/ColorPicker";
/* eslint-disable react/prop-types */

export function Ordering(base) {
  return {
    getConfig: function () {
      return {
        name: "Ordering",
        displayName: IdealStudio.i18n.t("Ordering.PluginName"),
        category: "evaluation",
        icon: "format_list_numbered",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        flavor: "react",
        isComplex: true,
        defaultCorrectAnswer: 0,
        defaultCurrentAnswer: false,
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            __score: {
              __name: i18n.t("configuration"),
              icon: "build",
              buttons: {
                nBoxes: {
                  __name: i18n.t("Ordering.Number"),
                  type: "number",
                  value: state.nBoxes,
                  max: 6,
                  min: 1,
                },
                showFeedback: {
                  __name: i18n.t("Ordering.ShowFeedback"),
                  type: "checkbox",
                  checked: state.showFeedback,
                },
                buttons: {
                  __name: i18n.t("MultipleChoice.WhichButtons"),
                  type: "radio",
                  value: state.buttons,
                  options: ["tryAgain", "seeAnswer"],
                  labels: [i18n.t("MultipleChoice.tryAgain"), i18n.t("MultipleChoice.seeAnswer")],
                },
                checkAnswerText: {
                  __name: i18n.t("TrueFalse.CheckAnswerText") || "Check Answer Button Text",
                  type: "text",
                  value: getButtonText(state.checkAnswerText, "MultipleChoice.checkAnswer"),
                },
                tryAgainText: {
                  __name: i18n.t("TrueFalse.TryAgainText") || "Try Again Button Text",
                  type: "text",
                  value: getButtonText(state.tryAgainText, "MultipleChoice.tryAgain"),
                  hide: state.buttons !== "tryAgain",
                },
                seeAnswerText: {
                  __name: i18n.t("TrueFalse.SeeAnswerText") || "See Answer Button Text",
                  type: "text",
                  value: getButtonText(state.seeAnswerText, "MultipleChoice.seeAnswer"),
                  hide: state.buttons !== "seeAnswer",
                },
                allowPartialScore: {
                  __name: i18n.t("MultipleAnswer.AllowPartialScore"),
                  type: "checkbox",
                  checked: state.allowPartialScore,
                },
                quizColor: {
                  __name: IdealStudio.i18n.t("Ordering.Color"),
                  type: "color",
                  value: state.quizColor || "rgba(237, 233, 254, 1)",
                },
              },
            },
            __buttonStyle: {
              __name: IdealStudio.i18n.t("TrueFalse.ButtonStyle") || "Button Style",
              icon: "palette",
              buttons: {
                buttonBackgroundColor: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBackground") || "Button Background Color",
                  type: "color",
                  value: state.buttonBackgroundColor || "#ede9fe",
                },
                buttonTextColor: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonTextColor") || "Button Text Color",
                  type: "color",
                  value: state.buttonTextColor || "#111827",
                },
                buttonBorderColor: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBorderColor") || "Button Border Color",
                  type: "color",
                  value: state.buttonBorderColor || "#ede9fe",
                },
                buttonBorderWidth: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBorderWidth") || "Button Border Width",
                  type: "range",
                  value: state.buttonBorderWidth || 1,
                  min: 0,
                  max: 5,
                  step: 1,
                },
                buttonBorderRadius: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBorderRadius") || "Button Border Radius",
                  type: "range",
                  value: state.buttonBorderRadius || 4,
                  min: 0,
                  max: 25,
                  step: 1,
                },
                buttonPadding: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonPadding") || "Button Padding",
                  type: "range",
                  value: state.buttonPadding || 8,
                  min: 4,
                  max: 20,
                  step: 1,
                },
                buttonFontSize: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonFontSize") || "Button Font Size",
                  type: "range",
                  value: state.buttonFontSize || 14,
                  min: 10,
                  max: 24,
                  step: 1,
                },
                buttonFontWeight: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonFontWeight") || "Button Font Weight",
                  type: "select",
                  value: state.buttonFontWeight || "normal",
                  options: [
                    "normal",
                    "bold",
                    "100",
                    "200",
                    "300",
                    "400",
                    "500",
                    "600",
                    "700",
                    "800",
                    "900",
                  ],
                  labels: [
                    i18n.t("styles.font_weight.normal") || "normal",
                    i18n.t("styles.font_weight.bold") || "bold",
                    i18n.t("styles.font_weight.100") || "100",
                    i18n.t("styles.font_weight.200") || "200",
                    i18n.t("styles.font_weight.300") || "300",
                    i18n.t("styles.font_weight.400") || "400",
                    i18n.t("styles.font_weight.500") || "500",
                    i18n.t("styles.font_weight.600") || "600",
                    i18n.t("styles.font_weight.700") || "700",
                    i18n.t("styles.font_weight.800") || "800",
                    i18n.t("styles.font_weight.900") || "900",
                  ],
                },
                buttonHoverBackgroundColor: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonHoverBackground") ||
                    "Button Hover Background Color",
                  type: "color",
                  value: state.buttonHoverBackgroundColor || "#ede9fe",
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("HotspotImages.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("HotspotImages.padding"),
                  type: "number",
                  value: 10,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("HotspotImages.background_color"),
                  type: "color",
                  value: "#ffffff",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("HotspotImages.border_size"),
                  type: "number",
                  value: 1,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("HotspotImages.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("HotspotImages.border_color"),
                  type: "color",
                  value: "#fff",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("HotspotImages.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("HotspotImages.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        nBoxes: 3,
        showFeedback: true,
        quizColor: "rgba(237, 233, 254, 1)",
        allowPartialScore: false,
        buttons: "tryAgain",
        checkAnswerText: null,
        tryAgainText: null,
        seeAnswerText: null,
        buttonBackgroundColor: "#ede9fe",
        buttonTextColor: "#111827",
        buttonBorderColor: "#ede9fe",
        buttonBorderWidth: 1,
        buttonBorderRadius: 4,
        buttonPadding: 8,
        buttonFontSize: 14,
        buttonFontWeight: "normal",
        buttonHoverBackgroundColor: "#ede9fe",
      };
    },
    getRenderTemplate: function (state, props = {}) {
      let answers = [];

      let quizColor = state.buttonBackgroundColor || state.quizColor || "rgba(237, 233, 254, 1)";
      let correctAnswers = "";

      for (let i = 0; i < state.nBoxes; i++) {
        // let clickHandler = (e)=>{
        //     props.setCorrectAnswer(parseInt(e.target.value, 10));
        // };
        let isCorrect = props.exercises.correctAnswer === i;
        answers.push(
          <div key={i + 1} className={"row answerRow"} data-answer-row={i}>
            {props.onMoveAnswer ? (
              <div className="assessment-reorder" contentEditable={false}>
                <button
                  type="button"
                  className="assessment-reorder-btn"
                  aria-label={i18n.t("messages.move_up") || "Move up"}
                  title={i18n.t("messages.move_up") || "Move up"}
                  disabled={i === 0}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onMoveAnswer(i, -1);
                  }}
                >
                  ▲
                </button>
                <button
                  type="button"
                  className="assessment-reorder-btn"
                  aria-label={i18n.t("messages.move_down") || "Move down"}
                  title={i18n.t("messages.move_down") || "Move down"}
                  disabled={i === state.nBoxes - 1}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onMoveAnswer(i, 1);
                  }}
                >
                  ▼
                </button>
              </div>
            ) : null}
            <div className={" answerPlaceholder"}>
              <div
                className={"answer_letter"}
                style={{
                  backgroundColor: quizColor,
                  color: state.buttonTextColor || "#111827",
                  borderColor: state.buttonBorderColor || "#ede9fe",
                  borderStyle: "solid",
                  borderWidth: `${state.buttonBorderWidth ?? 1}px`,
                  borderRadius: `${state.buttonBorderRadius ?? 4}px`,
                  fontSize: `${state.buttonFontSize ?? 14}px`,
                  fontWeight: state.buttonFontWeight || "normal",
                  padding: `0 ${state.buttonPadding ?? 8}px`,
                  width: "auto",
                  minWidth: "2em",
                }}
              >
                {i + 1}
              </div>
            </div>
            <div className={"col-xs-10 answerCol"}>
              <PluginPlaceholder
                {...props}
                key={i + 1}
                pluginContainerName={i18n.t("Ordering.Answer") + " " + (i + 1)}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "Ordering.Answer",
                      __suffix: " " + (1 + i),
                      __text: "<p>" + contentT("Ordering.Answer") + " " + (1 + i) + "</p>",
                    },
                  },
                ]}
                pluginContainer={"Answer" + i}
              />
            </div>
            {props.onRemoveAnswer ? (
              <button
                type="button"
                className="assessment-remove-answer"
                aria-label={i18n.t("messages.remove_answer")}
                title={i18n.t("messages.remove_answer")}
                onClick={(e) => {
                  e.stopPropagation();
                  props.onRemoveAnswer(i);
                }}
              >
                ×
              </button>
            ) : null}
          </div>
        );
        if (isCorrect) {
          correctAnswers +=
            state.letters === i18n.t("Ordering.ShowLetters") ? letterFromNumber(i) : i + 1;
        }
      }
      return (
        <div
          className={"exercisePlugin orderingPlugin"}
          style={{ "--q-btn-hover-bg": state.buttonHoverBackgroundColor || "#ede9fe" }}
        >
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <PluginPlaceholder
                {...props}
                key="1"
                pluginContainerName={i18n.t("Ordering.Question")}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "Ordering.Statement",
                      __text: "<p>" + contentT("Ordering.Statement") + "</p>",
                    },
                  },
                ]}
                pluginContainer={"Question"}
              />
            </div>
          </div>
          {answers}
          {props.onAddAnswer ? (
            <button
              type="button"
              className="assessment-add-answer"
              onClick={(e) => {
                e.stopPropagation();
                props.onAddAnswer();
              }}
            >
              + {i18n.t("messages.add_answer")}
            </button>
          ) : null}
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-2"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"TrueFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "MultipleChoice.TrueFeedbackMsg",
                      __text: "<p>" + contentT("MultipleChoice.TrueFeedbackMsg") + "</p>",
                    },
                  } /* , {plugin: 'HotspotImages', initialState:{url: 'nooo'}}*/,
                ]}
              />
            </div>
          </div>
          <div
            className={"row feedbackRow"}
            key={-3}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-3"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"FalseFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "MultipleChoice.FalseFeedbackMsg",
                      __text: "<p>" + contentT("MultipleChoice.FalseFeedbackMsg") + "</p>",
                    },
                  } /* , {plugin: 'HotspotImages', initialState:{url: 'nooo'}}*/,
                ]}
              />
            </div>
          </div>
          <div className={"row"} key={7}>
            <button
              onClick={(e) => props.tryAgainHandler()}
              style={{
                display: "none",
                height: "48px",
                backgroundColor: state.buttonBackgroundColor || "#ede9fe",
                color: state.buttonTextColor || "#111827",
                borderColor: state.buttonBorderColor || "#ede9fe",
                borderStyle: "solid",
                borderWidth: `${state.buttonBorderWidth ?? 1}px`,
                borderRadius: `${state.buttonBorderRadius ?? 4}px`,
                padding: `${state.buttonPadding ?? 8}px ${(state.buttonPadding ?? 8) * 1.5}px`,
                fontSize: `${state.buttonFontSize ?? 14}px`,
                fontWeight: state.buttonFontWeight || "normal",
              }}
              className={"tryButton"}
            >
              {getButtonText(state.tryAgainText, "MultipleChoice.tryAgain")}
            </button>
            <button
              onClick={(e) => props.submitPage(props.currentView, props.id)}
              style={{
                display: "inline-block",
                height: "48px",
                backgroundColor: state.buttonBackgroundColor || "#ede9fe",
                color: state.buttonTextColor || "#111827",
                borderColor: state.buttonBorderColor || "#ede9fe",
                borderStyle: "solid",
                borderWidth: `${state.buttonBorderWidth ?? 1}px`,
                borderRadius: `${state.buttonBorderRadius ?? 4}px`,
                padding: `${state.buttonPadding ?? 8}px ${(state.buttonPadding ?? 8) * 1.5}px`,
                fontSize: `${state.buttonFontSize ?? 14}px`,
                fontWeight: state.buttonFontWeight || "normal",
              }}
              className={"tryButton"}
            >
              {getButtonText(state.checkAnswerText, "MultipleChoice.checkAnswer")}
            </button>
          </div>
          <style
            dangerouslySetInnerHTML={{
              __html: `
                    .orderingPlugin input[type="radio"]  {
                      background-color: transparent;
                    }
                   .orderingPlugin input[type="radio"]:checked:after {
                      background-color: rgb(49 161 72);
                    }
                  `,
            }}
          />
        </div>
      );
    },

    /**
     * Check if the user's ordering is correct.
     * For Ordering, we consider it correct when the array is in ascending order,
     * matching the logic used in the visor (sorted copy equals original).
     */
    checkAnswer: function (currentAnswer, correctAnswer, toolbarState) {
      if (!Array.isArray(currentAnswer) || currentAnswer.length === 0) {
        return false;
      }

      try {
        const sorted = [...currentAnswer].sort((a, b) => a - b);
        const isCorrect = JSON.stringify(sorted) === JSON.stringify(currentAnswer);
        return isCorrect;
      } catch (e) {
        return false;
      }
    },
  };
}
/* eslint-enable react/prop-types */
